import styled from 'styled-components';
import { ToastContainer } from 'react-bootstrap';

/**
 * Toast stack sits above every other z-index layer (tooltip = 1070 is the highest).
 */
export const StyledToastContainer = styled(ToastContainer)`
  z-index: ${({ theme }) => theme.zIndex.tooltip + 10};
`;
